/** Factor del Excel Couriers_Control: peso volumétrico (kg) = volumen (m³) × 167. */
export const VOLUMETRIC_KG_PER_M3 = 167;

function roundTo(value, digits) {
  if (!Number.isFinite(value)) return 0;
  const factor = 10 ** digits;
  return Math.round((value + Number.EPSILON) * factor) / factor;
}

export function toNumber(value) {
  if (value === "" || value == null) return null;
  const raw =
    typeof value === "number" ? value : Number(String(value).replace(",", "."));
  return Number.isFinite(raw) ? raw : null;
}

export function computeCourierMeasures({
  largoCm,
  anchoCm,
  altoCm,
  pesoBrutoKg,
  coste,
  costeReal,
} = {}) {
  const largo = toNumber(largoCm) ?? 0;
  const ancho = toNumber(anchoCm) ?? 0;
  const alto = toNumber(altoCm) ?? 0;
  const volumenM3 = roundTo((largo * ancho * alto) / 1_000_000, 6);
  const pesoVolumetricoKg = roundTo(volumenM3 * VOLUMETRIC_KG_PER_M3, 6);
  const pesoBruto = toNumber(pesoBrutoKg) ?? 0;
  const pesoFacturableKg = roundTo(Math.max(pesoBruto, pesoVolumetricoKg), 6);
  const costeN = toNumber(coste);
  const realN = toNumber(costeReal);
  const diferencia =
    costeN == null || realN == null ? null : roundTo(realN - costeN, 4);

  return {
    volumenM3,
    pesoVolumetricoKg,
    pesoBrutoKg: roundTo(pesoBruto, 6),
    pesoFacturableKg,
    coste: costeN == null ? null : roundTo(costeN, 4),
    costeReal: realN == null ? null : roundTo(realN, 4),
    diferencia,
  };
}
